import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Tabs } from '@savgroup-front-common/core/src/atoms/Tabs';
import type { Tab } from '@savgroup-front-common/core/src/atoms/Tabs/Tabs.types';

import InventairePage from './InventairePage';
import StockPage from './StockPage';

const StockInventaireTabsScope = styled.div`
  width: 100%;

  /* Espace modéré sous le header (moins que le défaut du core, plus que la version très serrée) */
  & nav {
    padding-top: 0.5rem !important;
  }

  & button[data-testid^='stock-inventaire-tabs__buttonTab__'] {
    font-size: 16px !important;
    line-height: 1.25rem !important;
    padding-bottom: 1rem !important;
  }
`;

const TAB_STOCK = 'stock';
const TAB_INVENTAIRE = 'inventaire';

const StockInventairePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo<Tab[]>(
    () => [
      {
        name: TAB_STOCK,
        message: 'Stock',
        Component: StockPage,
      },
      {
        name: TAB_INVENTAIRE,
        message: 'Inventaire',
        Component: InventairePage,
      },
    ],
    [],
  );

  const initialActiveTab = useMemo(() => {
    if (location.pathname === '/inventaire') {
      return tabs[1];
    }

    return tabs[0];
  }, [location.pathname, tabs]);

  const handleTabChange = (tab: Tab) => {
    if (tab.name === TAB_STOCK) {
      navigate('/stock');
    }

    if (tab.name === TAB_INVENTAIRE) {
      navigate('/inventaire');
    }
  };

  return (
    <StockInventaireTabsScope>
      <Tabs
        tabs={tabs}
        initialActiveTab={initialActiveTab}
        onChange={handleTabChange}
        dataTestId="stock-inventaire-tabs"
        hasBottomBorder
      />
    </StockInventaireTabsScope>
  );
};

export default StockInventairePage;
